module.exports = __webpack_public_path__ + "static/media/cu06_ch01.fbf45d3a.png";